import { Space, Switch, Tooltip, Typography } from 'antd';
import { useOrganizationsStateContext } from 'providers/Organizations';
import { memo, useEffect } from 'react';
import { selectAnalyticsCommission } from 'store/analytics/selectors';
import { toggleCommission } from 'store/analytics/slice';
import { useAppDispatch, useAppSelector } from 'store/hooks';

const CommissionSwitcher = () => {
  const dispatch = useAppDispatch();
  const value = useAppSelector(selectAnalyticsCommission);

  const { parentSelected } = useOrganizationsStateContext();

  const onValueChange = (e: boolean) => {
    dispatch(toggleCommission(e));
  };

  useEffect(() => {
    if (parentSelected === 'all') {
      dispatch(toggleCommission(false));
    } else {
      dispatch(toggleCommission(true));
    }
  }, [dispatch, parentSelected]);

  if (parentSelected === 'all') {
    return null;
  }

  return (
    <Tooltip title="When enabled, displays the partner’s share (commission) rather than full revenue">
      <Space>
        <Typography.Text>Show Revenue as Commission</Typography.Text>
        <Switch
          disabled={parentSelected === 'all'}
          onChange={onValueChange}
          value={value}
        />
      </Space>
    </Tooltip>
  );
};

export default memo(CommissionSwitcher);
